import {
  TOP_DSE_REQUEST,
  TOP_DSE_SUCCESS,
  TOP_DSE_FAIL,
  GET_LOGIN_STATUS_REQUEST,
  GET_LOGIN_STATUS_SUCCESS,
  GET_LOGIN_STATUS_FAIL,
  GET_APP_USAGE_SUCCESS,
  GET_APP_USAGE_REQUEST,
  GET_APP_USAGE_FAIL,
  LOCATION_UPDATE_REQUEST,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_UPDATE_FAIL,
  PARTS_ANALYSIS_REQUEST,
  PARTS_ANALYSIS_SUCCESS,
  PARTS_ANALYSIS_FAIL,
  PARTS_ANALYSIS_ADDITIONAL_REQUEST,
  PARTS_ANALYSIS_ADDITIONAL_SUCCESS,
  PARTS_ANALYSIS_ADDITIONAL_FAIL,
  CUSTOMER_REPORT_REQUEST,
  CUSTOMER_REPORT_SUCCESS,
  CUSTOMER_REPORT_FAIL,
  VISIT_TRACKER_REQUEST,
  VISIT_TRACKER_SUCCESS,
  VISIT_TRACKER_FAIL,
  PARTIES_VISITED_TOPDSE_REQUEST,
  PARTIES_VISITED_TOPDSE_SUCCESS,
  PARTIES_VISITED_TOPDSE_FAIL,
  LOGOUT,
  GET_LOGIN_ADDITIONAL_DATA_SUCCESS,
  GET_LOGIN_ADDITIONAL_DATA_FAIL,
  GET_LOGIN_ADDITIONAL_DATA_REQUEST,
  CUSTOMER_ADDITIONAL_DATA_REQUEST,
  CUSTOMER_ADDITIONAL_DATA_SUCCESS,
  CUSTOMER_ADDITIONAL_DATA_FAIL,
  IW_RESEARCH_REQUEST,
  IW_RESEARCH_SUCCESS,
  IW_RESEARCH_FAIL,
  NO_STOCK_REQUEST,
  NO_STOCK_SUCCESS,
  NO_STOCK_FAIL,
  GET_PARTSKART_LOGIN_REQUEST,
  GET_PARTSKART_LOGIN_SUCCESS,
  GET_PARTSKART_LOGIN_FAIL,
} from "../constants/constants";

const topDSEInitialState = {
  loading: true,
  top_dse_data: [],
  error: "",
  total_orders_quantity: 0,
  total_order_value: 0,
  pendingRequestsCount: 0,
};
const partsAnalysisInitialData = {
  loading: true,
  parts_analysis_data: [],
  pendingRequestsCount: 0,
  error: "",
};
const partsAdditionalDataState = {
  downloadLoader: false,
  additional_worksheet_data: [],
  pendingRequestsCount: 0,
};

const appUsageStatusInitialState = {
  loading: true,
  label: [],
  dateRange: [],
  app_usage_data: [],
  dseLoggedIn: "",
  panIndiaPersentage: "",
  error: "",
  dataLevel: "",
  payload: null,
  pendingRequestsCount: 0,
};
const locationInitialState = {
  location_update_results: [],
  loading: false,
  error: null,
  payload: null,
  pendingRequestsCount: 0,
};
const customerReportInitialState = {
  label: "",
  downloadLoader: false,
  additional_worksheet_data: [],
  customer_report_data: [],
  overall_percentage: 0,
  total_visited_parties: 0,
  aggregate_parties_visited: 0,
  total_parties: 0,
  loading: false,
  error: null,
  unique_visited_parties: 0,
  pendingRequestsCount: 0,
  payload: null,
};
const topPartiesVisitedDSE = {
  parties_visited_topDSE: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0,
};
// login status
const loginStatusInitialState = {
  loading: true,
  login_status_data: [],
  downloadLoader: false,
  additional_worksheet_data: [],
  dseLoggedIn: 0,
  panIndiaPersentage: 0,
  error: "",
  pendingRequestsCount: 0,
  payload: null,
};

// partskart app login status
const partskartAppLoginInitialState = {
  loading: true,
  partskart_loginstatus_data: [],
  downloadLoader: false,
  additional_worksheet_data: [],
  partiesLoggedIn: 0,
  panIndiaPersentage: 0,
  error: "",
  pendingRequestsCount: 0,
  payload: null,
};

// Digital CRC - IW Research
const iwResearchInitialState = {
  iwResearch_results: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0, // New state to track pending requests
  payload: null,
};

// No Stock
const noStockInitialState = {
  noStock_results: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0, // New state to track pending requests
  payload: null,
};
export const loginStatusReducer = (state = loginStatusInitialState, action) => {
  switch (action.type) {
    case GET_LOGIN_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        dseLoggedIn: 0,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
        login_status_data: [],
      };

    case GET_LOGIN_STATUS_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        login_status_data: action.payload.data,
        dseLoggedIn: parseInt(action.payload.dseLoggedIn),
        panIndiaPersentage: action.payload.panIndiaPersentage,
        payload: action.payload,
      };

    case GET_LOGIN_STATUS_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        login_status_data: [],
        dseLoggedIn: 0,
        error: action.payload,
        payload: null,
      };
    case GET_LOGIN_ADDITIONAL_DATA_REQUEST:
      return {
        ...state,
        downloadLoader: true,
      };

    case GET_LOGIN_ADDITIONAL_DATA_SUCCESS:
      return {
        ...state,
        downloadLoader: false,
        additional_worksheet_data: action.payload,
      };

    case GET_LOGIN_ADDITIONAL_DATA_FAIL:
      return {
        ...state,
        downloadLoader: false,
        additional_worksheet_data: [],
      };
    case LOGOUT:
      return loginStatusInitialState;

    default:
      return state;
  }
};

export const partskartLoginStatusReducer = (
  state = partskartAppLoginInitialState,
  action
) => {
  switch (action.type) {
    case GET_PARTSKART_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        partiesLoggedIn: 0,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
        partskart_loginstatus_data: [],
      };

    case GET_PARTSKART_LOGIN_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        partskart_loginstatus_data: action.payload.data,
        partiesLoggedIn: parseInt(action.payload.partiesLoggedIn),
        panIndiaPersentage: action.payload.panIndiaPersentage,
        payload: action.payload,
      };

    case GET_PARTSKART_LOGIN_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        partskart_loginstatus_data: [],
        partiesLoggedIn: 0,
        error: action.payload,
        payload: null,
      };

    case LOGOUT:
      return partskartAppLoginInitialState;

    default:
      return state;
  }
};
// app usage status
export const appUsageStatusReducer = (
  state = appUsageStatusInitialState,
  action
) => {
  switch (action.type) {
    case GET_APP_USAGE_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
      };

    case GET_APP_USAGE_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        label: action.payload.label,
        dateRange:
          action.payload.dateRange && action.payload.dateRange.length
            ? action.payload.dateRange
            : [],
        app_usage_data: action.payload.data,
        dseLoggedIn: action.payload.dseLoggedIn,
        panIndiaPersentage: action.payload.panIndiaPersentage,
        payload: action.payload,
        dataLevel: action.payload.dataLevel,
      };

    case GET_APP_USAGE_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        label: [],
        app_usage_data: [],
        dateRange: [],
        dataLevel: "",
        error: action.payload,
        payload: null,
      };
    case LOGOUT:
      return appUsageStatusInitialState;

    default:
      return state;
  }
};

// top DSE reducer
export const topDSEKPIReducer = (state = topDSEInitialState, action) => {
  switch (action.type) {
    case TOP_DSE_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        total_orders_quantity: 0,
        total_order_value: 0,
      };

    case TOP_DSE_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        top_dse_data: action.payload,
        total_orders_quantity: 0,
        total_order_value: 0,
        error: "",
      };

    case TOP_DSE_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        top_dse_data: [],
        error: action.payload,
        total_orders_quantity: 0,
        total_order_value: 0,
      };

    case LOGOUT:
      return topDSEInitialState;

    default:
      return state;
  }
};

export const locationUpdateReducer = (state = locationInitialState, action) => {
  switch (action.type) {
    case LOCATION_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
      };

    case LOCATION_UPDATE_SUCCESS:
      const pendingLocationAfterSuccess = Math.max(
        state.pendingRequestsCount - 1,
        0
      ); // Decrement on success
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingLocationAfterSuccess,
        loading: pendingLocationAfterSuccess > 0, // Keep loader if there are pending requests
        location_update_results: action.payload.results,
        payload: action.payload,
        error: "",
      };

    case LOCATION_UPDATE_FAIL:
      const pendingLocatonAfterFail = Math.max(
        state.pendingRequestsCount - 1,
        0
      ); // Decrement on failure
      return {
        ...state,
        // loading: false,
        location_update_results: [],
        error: action.payload,
        payload: null,
        pendingRequestsCount: pendingLocatonAfterFail,
        loading: pendingLocatonAfterFail > 0, // Keep loader if there are pending requests
      };

    case LOGOUT:
      return locationInitialState;

    default:
      return state;
  }
};

export const partsAdditionalDataReducer = (
  state = partsAdditionalDataState,
  action
) => {
  switch (action.type) {
    case PARTS_ANALYSIS_ADDITIONAL_REQUEST:
      return {
        ...state,
        downloadLoader: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case PARTS_ANALYSIS_ADDITIONAL_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        // downloadLoader: false,
        pendingRequestsCount: pendingAfterSuccess,
        downloadLoader: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        additional_worksheet_data: action.payload,
      };

    case PARTS_ANALYSIS_ADDITIONAL_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // downloadLoader: false,
        pendingRequestsCount: pendingAfterFail,
        downloadLoader: pendingAfterFail > 0, // Keep loader if there are pending requests
        additional_worksheet_data: [],
      };
    case LOGOUT:
      return partsAdditionalDataState;
    default:
      return state;
  }
};
export const partsAnalysisReducer = (
  state = partsAnalysisInitialData,
  action
) => {
  switch (action.type) {
    case PARTS_ANALYSIS_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case PARTS_ANALYSIS_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        parts_analysis_data: action.payload,
        error: "",
      };

    case PARTS_ANALYSIS_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        parts_analysis_data: [],
        error: action.payload,
      };

    case LOGOUT:
      return partsAnalysisInitialData;

    default:
      return state;
  }
};

export const customerReportReducer = (
  state = customerReportInitialState,
  action
) => {
  switch (action.type) {
    case CUSTOMER_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        unique_visited_parties: 0,
        payload: null,
      };

    case CUSTOMER_REPORT_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        label: action.payload.label,
        customer_report_data: action.payload.data,
        payload: action.payload,
        total_visited_parties: action.payload.total_visited_parties,
        aggregate_parties_visited: action.payload.aggregate_parties_visited,
        overall_percentage: action.payload.overall_percentage,
        total_parties: action.payload.total_parties,
        unique_visited_parties: 0,
        error: "",
      };

    case CUSTOMER_REPORT_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        customer_report_data: [],
        label: "",
        total_visited_parties: 0,
        aggregate_parties_visited: 0,
        total_parties: 0,
        overall_percentage: 0,
        error: action.payload,
        unique_visited_parties: 0,
        payload: null,
      };
    case CUSTOMER_ADDITIONAL_DATA_REQUEST:
      return {
        ...state,
        downloadLoader: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case CUSTOMER_ADDITIONAL_DATA_SUCCESS:
      const pendingCustomerDataAfterSuccess = Math.max(
        state.pendingRequestsCount - 1,
        0
      ); // Decrement on success
      return {
        ...state,
        //downloadLoader: false,
        pendingRequestsCount: pendingCustomerDataAfterSuccess,
        downloadLoader: pendingCustomerDataAfterSuccess > 0, // Keep loader if there are pending requests
        additional_worksheet_data: action.payload,
      };

    case CUSTOMER_ADDITIONAL_DATA_FAIL:
      const pendingCustomerDataAfterFail = Math.max(
        state.pendingRequestsCount - 1,
        0
      ); // Decrement on failure
      return {
        ...state,
        //downloadLoader: false,
        pendingRequestsCount: pendingCustomerDataAfterFail,
        downloadLoader: pendingCustomerDataAfterFail > 0, // Keep loader if there are pending requests
        additional_worksheet_data: [],
      };
    case LOGOUT:
      return customerReportInitialState;

    default:
      return state;
  }
};

const visitTrackerInitialState = {
  visit_tracker: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0,
};

export const visitTrackerReducer = (
  state = visitTrackerInitialState,
  action
) => {
  switch (action.type) {
    case VISIT_TRACKER_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        visit_tracker: [],
      };

    case VISIT_TRACKER_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        visit_tracker: action.payload.results,
        error: "",
      };

    case VISIT_TRACKER_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        visit_tracker: [],
      };

    case LOGOUT:
      return visitTrackerInitialState;
    default:
      return state;
  }
};
// Parties visited TOP DSE
export const partiesVisitedTopDSE = (state = topPartiesVisitedDSE, action) => {
  switch (action.type) {
    case PARTIES_VISITED_TOPDSE_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case PARTIES_VISITED_TOPDSE_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        parties_visited_topDSE: action.payload,
        error: "",
      };

    case PARTIES_VISITED_TOPDSE_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        //loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        parties_visited_topDSE: [],
        error: action.payload,
      };

    case LOGOUT:
      return topPartiesVisitedDSE;

    default:
      return state;
  }
};

export const iwResearchReducer = (state = iwResearchInitialState, action) => {
  switch (action.type) {
    case IW_RESEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
      };

    case IW_RESEARCH_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        iwResearch_results: action.payload.results,
        payload: action.payload,
        error: "",
      };

    case IW_RESEARCH_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        iwResearch_results: [],
        error: action.payload,
        payload: null,
      };

    case LOGOUT:
      return iwResearchInitialState;

    default:
      return state;
  }
};

export const noStockReducer = (state = noStockInitialState, action) => {
  switch (action.type) {
    case NO_STOCK_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
        payload: null,
      };

    case NO_STOCK_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      return {
        ...state,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        noStock_results: action.payload.results,
        payload: action.payload,
        error: "",
      };

    case NO_STOCK_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        noStock_results: [],
        error: action.payload,
        payload: null,
      };

    case LOGOUT:
      return noStockInitialState;

    default:
      return state;
  }
};
